import { render, staticRenderFns } from "./EscalationDataUpdate.vue?vue&type=template&id=488ec718&scoped=true&"
import script from "./EscalationDataUpdate.vue?vue&type=script&lang=js&"
export * from "./EscalationDataUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EscalationDataUpdate.vue?vue&type=style&index=0&id=488ec718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ec718",
  null
  
)

export default component.exports